// Servicio para manejo de LocalStorage con validación y tipado
class LocalStorageService {
  constructor() {
    this.prefix = 'pos_abarrotes_';
  }

  // Generar clave con prefijo
  getKey(key) {
    return `${this.prefix}${key}`;
  }

  // Guardar datos
  set(key, value) {
    try {
      const serializedValue = JSON.stringify(value);
      localStorage.setItem(this.getKey(key), serializedValue);
      return true;
    } catch (error) {
      console.error('Error al guardar en localStorage:', error);
      return false;
    }
  }

  // Obtener datos
  get(key, defaultValue = null) {
    try {
      const item = localStorage.getItem(this.getKey(key));
      if (item === null) return defaultValue;
      return JSON.parse(item);
    } catch (error) {
      console.error('Error al leer de localStorage:', error);
      return defaultValue;
    }
  }

  // Eliminar datos
  remove(key) {
    try {
      localStorage.removeItem(this.getKey(key));
      return true;
    } catch (error) {
      console.error('Error al eliminar de localStorage:', error);
      return false;
    }
  }

  // Limpiar todos los datos de la app
  clear() {
    try {
      const keys = Object.keys(localStorage);
      keys.forEach(key => {
        if (key.startsWith(this.prefix)) {
          localStorage.removeItem(key);
        }
      });
      return true;
    } catch (error) {
      console.error('Error al limpiar localStorage:', error);
      return false;
    }
  }

  // Verificar si existe una clave
  exists(key) {
    return localStorage.getItem(this.getKey(key)) !== null;
  }

  // === MÉTODOS ESPECÍFICOS PARA LA APP ===

  // Configuración de la aplicación
  setAppConfig(config) {
    return this.set('app_config', config);
  }

  getAppConfig() {
    return this.get('app_config', {
      theme: 'light',
      language: 'es',
      currency: 'MXN',
      taxRate: 0.16,
      defaultPrinter: null
    });
  }

  // Usuario actual
  setCurrentUser(user) {
    return this.set('current_user', user);
  }

  getCurrentUser() {
    return this.get('current_user', null);
  }

  // Carrito de compras temporal
  setCart(cart) {
    return this.set('temp_cart', cart);
  }

  getCart() {
    return this.get('temp_cart', []);
  }

  clearCart() {
    return this.remove('temp_cart');
  }

  // Configuración de impresoras
  setPrinterConfig(config) {
    return this.set('printer_config', config);
  }

  getPrinterConfig() {
    return this.get('printer_config', {
      defaultPrinter: null,
      receiptPrinter: null,
      kitchenPrinter: null,
      autoSilentPrint: true
    });
  }

  // Últimas ventas (cache)
  setRecentSales(sales) {
    return this.set('recent_sales', sales);
  }

  getRecentSales() {
    return this.get('recent_sales', []);
  }

  // Productos favoritos/frecuentes
  setFavoriteProducts(products) {
    return this.set('favorite_products', products);
  }

  getFavoriteProducts() {
    return this.get('favorite_products', []);
  }
}

// Crear instancia singleton
const localStorageService = new LocalStorageService();

export default localStorageService;